const PRODUCTION_APP_HOSTNAME = 'platform.quantchecklabs.com';

const parseHostname = (origin: string): string | null => {
  try {
    return new URL(origin).hostname.toLowerCase();
  } catch {
    return null;
  }
};

export const isDailyPulseEnabled = (): boolean => {
  const configuredOrigin = (process.env.REACT_APP_CANONICAL_APP_ORIGIN || '').trim();
  const configuredHostname = parseHostname(configuredOrigin);

  if (configuredHostname) {
    return configuredHostname !== PRODUCTION_APP_HOSTNAME;
  }

  if (typeof window !== 'undefined') {
    return window.location.hostname.toLowerCase() !== PRODUCTION_APP_HOSTNAME;
  }

  return true;
};
